// extracted by mini-css-extract-plugin
module.exports = {"main":"PageLayout__main__1zHWJ","notificationWrapper":"PageLayout__notificationWrapper__1odJV"};